import {Form} from "react-bootstrap";
import React from "react";
import NumberSeparator from "./NumberSeparator";
import Parse from "./parse";

class FieldToText {
    constructor() {
    }

    static get(id = "id") {
        return <span style={{fontSize: "13px"}} className="text-end text-muted" id={id}></span>

    }

    static set(idAndVal = [["idName", "value"]]) {
        try {
            idAndVal.length != 0 && idAndVal.map(singleIdAndVal => {
                try {
                    document.getElementById(singleIdAndVal[0]).innerText = Parse.toNumber(singleIdAndVal[1]) > 999 ? NumberSeparator.format(Parse.toNumber(singleIdAndVal[1]), "", 2) : ""
                } catch (e) {

                }
            })
        } catch (e) {

        }

    }

    static default(idArr = []) {
        try {
            idArr.length != 0 && idArr.map(singleId => {
                try {
                    document.getElementById(singleId).innerText = ""
                } catch (e) {

                }
            })
        } catch (e) {

        }
    }
}

export default FieldToText